import { render, staticRenderFns } from "./MaterialRequest.vue?vue&type=template&id=16d8d73d"
import script from "./MaterialRequest.vue?vue&type=script&lang=js"
export * from "./MaterialRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports